import { render, staticRenderFns } from "./StorageHome.vue?vue&type=template&id=082e6b25"
import script from "./StorageHome.vue?vue&type=script&lang=js"
export * from "./StorageHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports